import { Deserializable } from "../_interfaces/deserializable.interface";

export class Question implements Deserializable {
  uuid: string;
  question: string;
  option_0: string;
  option_1: string;
  option_2: string;
  option_3: string;
  option_4: string;

  deserialize(input: any) {
    this.uuid = input.uuid;
    this.question = input.question;
    this.option_0 = input.option_0;
    this.option_1 = input.option_1;
    this.option_2 = input.option_2;
    this.option_3 = input.option_3;
    this.option_4 = input.option_4;

    return this;
  }
}
